

export function button5_click(event) {lightbox1_mouseIn(event)
	// Add your code for this event here: 
}